import { render, staticRenderFns } from "./LaowaiSurvivalView.vue?vue&type=template&id=6ce59964&"
import script from "./LaowaiSurvivalView.vue?vue&type=script&lang=js&"
export * from "./LaowaiSurvivalView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports